/* unplugin-vue-components disabled */import script from "./headTabbarM.vue?vue&type=script&setup=true&lang=js"
export * from "./headTabbarM.vue?vue&type=script&setup=true&lang=js"

import "./headTabbarM.vue?vue&type=style&index=0&id=1743871c&scoped=true&lang=less"

import exportComponent from "../../node_modules/.pnpm/vue-loader@17.4.2_@vue+comp_e16590e957a4dff7099c04c4dde027e6/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1743871c"]])

export default __exports__